export function getView(hasSignature) {
  return hasSignature === false ? 'AddAction' : 'No'
}
